import { RequisitionPerformanceReportPageComponent } from './requisition-performance-report-page.component';
import { RequisitionPerformanceReportModule } from './requisitionPerformanceReport/requisition-performance-report.module';
export const RequisitionPerformanceReportPageModule = angular
    .module('4dot5.missioncontrolmodule.reportsmodule.requisitionPerformanceReportPageModule', [RequisitionPerformanceReportModule])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('missioncontrol.reports.requisitionPerformanceReport', {
            url: '/requisitionPerformanceReport',
            component: RequisitionPerformanceReportPageComponent.selector,
            data: {
                requireLogin: true
            },
            params: {
                viewReportBy: null
            }
        });
    }
])
    .component(RequisitionPerformanceReportPageComponent.selector, RequisitionPerformanceReportPageComponent.component)
    .name;
//# sourceMappingURL=requisition-performance-report-page.module.js.map